import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    originalImageKey: 'ai/input/ai-video-dub/',
    resultImageKey: 'ai/export/ai-video-dub/',
    resultCoverKey: 'ai/export/ai-video-dub/cover/',
    historyListType: 25,
    freeLimitType: 'video-to-sound-effect',
    currentMenuName: 'ai-video-dub',

    libPath: environment === LOCAL ? `/public/lib/` : `/app/ai-tools/lib/`,

    presetPreviewPath:
        environment === LOCAL ? `/public/resource/ai-video-dub/` : `/app/ai-tools/resource/ai-video-dub/`,
    presetListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/ai-video-dub/presetList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/ai-video-dub/presetList.json?v=${FJVersionConfig.staticPathVersion}`,

    defaultBoxBgUrl:
        environment === LOCAL
            ? `/public/resource/ai-video-dub/img/bg.png`
            : `/app/ai-tools/resource/ai-video-dub/img/bg.png`,
};
